import { isFilterComplete, isGroupByFilter, isMultiValueOperator, isMatchAllFilter } from './AdHocFiltersVariable.js';
import { escapeOriginFilterUrlDelimiters, toUrlCommaDelimitedString, unescapeUrlDelimiters } from '../utils.js';

class AdHocFiltersVariableUrlSyncHandler {
  constructor(_variable) {
    this._variable = _variable;
  }
  getKey() {
    return `var-${this._variable.state.name}`;
  }
  getKeys() {
    return [this.getKey()];
  }
  getUrlState() {
    const filters = this._variable.state.filters;
    const originFilters = this._variable.state.originFilters;
    let value = [];
    if (filters.length === 0 && (originFilters == null ? void 0 : originFilters.length) === 0) {
      return { [this.getKey()]: [""] };
    }
    if (originFilters == null ? void 0 : originFilters.length) {
      value.push(
        ...originFilters.filter((f) => isFilterComplete(f) && !f.hidden && f.origin && !isGroupByFilter(f) && f.restorable).map((f) => toArray(f).map(escapeOriginFilterUrlDelimiters).join("|").concat(`#${f.origin}#restorable`))
      );
      if (this._variable.isGroupByRestorable()) {
        const activeGroupBys = originFilters.filter((f) => isGroupByFilter(f) && f.origin && !f.dismissedGroupBy);
        if (activeGroupBys.length > 0) {
          value.push(
            ...activeGroupBys.map(
              (f) => toArray(f).map(escapeOriginFilterUrlDelimiters).join("|").concat(`#${f.origin}#restorable`)
            )
          );
        } else {
          value.push(`|groupBy#dashboard#restorable`);
        }
      }
    }
    if (filters.length) {
      value.push(
        ...filters.filter(isFilterComplete).filter((filter) => !filter.hidden).map((filter) => toArray(filter).map(escapeOriginFilterUrlDelimiters).join("|"))
      );
    }
    return {
      [this.getKey()]: value.length ? value : [""]
    };
  }
  updateFromUrl(values) {
    const urlValue = values[this.getKey()];
    if (urlValue == null) {
      return;
    }
    const filters = deserializeUrlToFilters(urlValue);
    const originFilters = updateOriginFilters([...this._variable.state.originFilters || []], filters);
    this._variable.setState({
      filters: filters.filter((f) => !f.origin),
      originFilters
    });
  }
}
function updateOriginFilters(prevOriginFilters, filters) {
  const updatedOriginFilters = [...prevOriginFilters];
  const urlGroupByKeys = /* @__PURE__ */ new Set();
  for (const f of filters) {
    if (isGroupByFilter(f) && f.origin && f.restorable) {
      urlGroupByKeys.add(f.key);
    }
  }
  for (let i = 0; i < filters.length; i++) {
    const foundOriginFilterIndex = prevOriginFilters.findIndex(
      (f) => f.key === filters[i].key && isGroupByFilter(f) === isGroupByFilter(filters[i])
    );
    const isMatchedOrigin = foundOriginFilterIndex > -1 && filters[i].origin === prevOriginFilters[foundOriginFilterIndex].origin;
    if (!isMatchedOrigin && filters[i].origin === "dashboard") {
      delete filters[i].origin;
      delete filters[i].restorable;
    }
    if (isGroupByFilter(filters[i])) {
      continue;
    }
    if (isMatchedOrigin) {
      if (isMatchAllFilter(filters[i])) {
        filters[i].matchAllFilter = true;
      }
      updatedOriginFilters[foundOriginFilterIndex] = filters[i];
    } else if (foundOriginFilterIndex === -1 && filters[i].origin === "scope" && filters[i].restorable) {
      updatedOriginFilters.push(filters[i]);
    }
  }
  if (urlGroupByKeys.size > 0) {
    const allDismissed = urlGroupByKeys.has("");
    for (let i = 0; i < updatedOriginFilters.length; i++) {
      const f = updatedOriginFilters[i];
      if (isGroupByFilter(f) && f.origin) {
        if (allDismissed || !urlGroupByKeys.has(f.key)) {
          updatedOriginFilters[i] = { ...f, dismissedGroupBy: true, restorable: true };
        } else {
          updatedOriginFilters[i] = { ...f, dismissedGroupBy: false, restorable: true };
        }
      }
    }
  }
  return updatedOriginFilters;
}
function deserializeUrlToFilters(value) {
  if (Array.isArray(value)) {
    const values = value;
    return values.map(toFilter).filter(isFilter);
  }
  const filter = toFilter(value);
  return filter === null ? [] : [filter];
}
function toArray(filter) {
  var _a;
  const result = [toUrlCommaDelimitedString(filter.key, filter.keyLabel), filter.operator];
  if (isGroupByFilter(filter)) {
    return result;
  }
  if (isMultiValueOperator(filter.operator)) {
    filter.values.forEach((value, index) => {
      var _a2;
      result.push(toUrlCommaDelimitedString(value, (_a2 = filter.valueLabels) == null ? void 0 : _a2[index]));
    });
  } else {
    result.push(toUrlCommaDelimitedString(filter.value, (_a = filter.valueLabels) == null ? void 0 : _a[0]));
  }
  return result;
}
function toFilter(urlValue) {
  var _a;
  if (typeof urlValue !== "string" || urlValue.length === 0) {
    return null;
  }
  const [filter, origin, restorable] = urlValue.split("#");
  const [key, keyLabel, operator, _operatorLabel, ...values] = filter.split("|").reduce((acc, v) => {
    const [key2, label] = v.split(",");
    acc.push(key2, label != null ? label : key2);
    return acc;
  }, []).map(unescapeUrlDelimiters);
  return {
    key,
    keyLabel,
    operator,
    value: (_a = values[0]) != null ? _a : "",
    values: isMultiValueOperator(operator) ? values.filter((_, index) => index % 2 === 0) : void 0,
    valueLabels: values.length > 0 ? values.filter((_, index) => index % 2 === 1) : void 0,
    condition: "",
    ...isFilterOrigin(origin) && { origin },
    ...!!restorable && { restorable: true }
  };
}
function isFilterOrigin(value) {
  return value === "scope" || value === "dashboard";
}
function isFilter(filter) {
  return filter !== null && typeof filter.key === "string" && typeof filter.value === "string";
}

export { AdHocFiltersVariableUrlSyncHandler, toArray };
//# sourceMappingURL=AdHocFiltersVariableUrlSyncHandler.js.map
